<template>
  <b-form-group
    label="Metin"
    label-for="content"
  >
    <validation-provider
      #default="{ errors }"
      name="Metin"
      rules="required"
    >
      <b-form-textarea
        id="content"
        v-model="itemData.content"
        placeholder="Metin"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'ContentNotificationsText',
  components: { ValidationProvider, BFormTextarea, BFormGroup },
  computed: {
    itemData() {
      return this.$store.getters['notifications/dataItem']
    },
  },
}
</script>
